import { render } from "./ServerStatus.vue?vue&type=template&id=5ed05993&scoped=true&ts=true"
import script from "./ServerStatus.vue?vue&type=script&lang=ts"
export * from "./ServerStatus.vue?vue&type=script&lang=ts"

import "./ServerStatus.vue?vue&type=style&index=0&id=5ed05993&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed05993"]])

export default __exports__